import { createSlice } from '@reduxjs/toolkit';
import { FONT_SIZES } from 'src/enums';

/*
|-----------------------------------------------------------------
| Initial State
|-----------------------------------------------------------------
|
*/

interface IAccessibilityState {
  fontSize: number;
  fontSizeIndex: number;
  isDarkMode: boolean;
}

const initialState: IAccessibilityState = {
  fontSize: 1,
  fontSizeIndex: 0,
  isDarkMode: true
};

/*
|-----------------------------------------------------------------
| Create Slice
|-----------------------------------------------------------------
|
*/

const accessibilityState = createSlice({
  name: 'accessibilityState',
  initialState,
  reducers: {
    toggleFontSize(state) {
      // increase the fontIndex untill it goes to the end
      if (state.fontSizeIndex < FONT_SIZES.length - 1) {
        state.fontSizeIndex++;
      } else {
        state.fontSizeIndex = 0;
      }
      // update state
      state.fontSize = FONT_SIZES[state.fontSizeIndex];
    },
    toggleDarkMode(state) {
      if (state.isDarkMode) {
        state.isDarkMode = false;
      } else {
        state.isDarkMode = true;
      }
    }
  }
});

/*
|-----------------------------------------------------------------
| Export actions & reducer
|-----------------------------------------------------------------
|
*/

export const accessibilityActions = {
  ...accessibilityState.actions
};
export { default as accessibilitySelectors } from './accessibility.selectors';

export default accessibilityState.reducer;
